/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { get } from "@ember/object";
import ScaleSurveyEditionFormComponent from "parog-web/components/abstract/scale-survey-edition-form";
import FastDeclaredJournalEvent from "parog-web/models/fast-declared-journal-event";
import fastScoreDescription from "parog-web/utils/fast-score-description";

export default class FastEditionFormComponent extends ScaleSurveyEditionFormComponent {
  static forcDisplayName = "Functional Assessment Staging (FAST)";

  static fullComponentId = "scale-surveys/fast-edition-form";

  static journalEventClass = FastDeclaredJournalEvent;

  get maximalScore() {
    return 72;
  }

  get numberOfItems() {
    return 24;
  }

  _computeScore(payload) {
    const number = this.questionIds.reduce(
      (total, index) => total + parseInt(get(payload, index)),
      0
    );

    return {
      number,
      description: fastScoreDescription(number)
    };
  }
}
